<template>
  <BaseDialog
    :value="dialogState"
    max-width="700"
    @click:outside="close"
    @keydown.esc="close"
  >
    <template #modal>
      <BaseCosmoCard v-if="activeFolder">
        <template #title>
          <div class="modal_header">
            <BaseTitle
              class="modal_header_title"
              v-text="$t('folder.delete', { folderName: activeFolder.name })"
            />
            <BaseButtonIcon icon="$mdiClose" @click="close()" />
          </div>
        </template>
        <div class="modal_content">
          <base-text-field
            v-model="confirmText"
            :placeholder="$t('folder.deletePlaceHolder')"
          />
        </div>
        <div class="modal_footer">
          <BaseButton color="gray" type="secondary" @click="close()">
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            color="secondary"
            :loading="isSubmiting"
            :disabled="confirmText !== 'SUPPRIMER'"
            @click="submit()"
          >
            {{ $t("utils.delete") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
import { mapState } from "vuex";
import FolderAPI from "@/modules/Folder/Services/folder.api";

export default {
  name: "FolderDeleteDialog",
  data() {
    return {
      isSubmiting: false,
      confirmText: "",
    };
  },
  computed: {
    ...mapState({
      activeFolder: (state) => state.folder.activeFolder,
      dialogState: (state) => state.folder.modals.isDeleteFolderModalOpen,
    }),
  },
  methods: {
    close() {
      this.$store.commit("folder/SET_MODAL_DELETE_FOLDER", false);
      this.confirmText = "";
    },
    async submit() {
      this.isSubmiting = true;
      try {
        await FolderAPI.deleteOrganizationFolder(
          this.$route.params.organizationId,
          this.$route.params.folderId
        );
        this.$store.dispatch("snackbar/active", {
          message: this.$t("folder.deletedSuccesfully"),
          type: "SUCCESS",
        });
        this.$router.push({
          name: "folderList",
          params: { organizationId: this.$route.params.organizationId },
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 16px;
  flex-wrap: wrap;
  .modal_header_title {
    flex: 1;
  }
}
.modal_content {
  padding: 24px 10px;

  & > * {
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .bo_text {
    text-align: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #353542;
  }
  .text_danger {
    color: #ff5267;
  }
}
.modal_footer {
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > * {
    margin-left: 16px;
  }
}
</style>
